import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import Subnav from 'components/Subnav';
import { useTranslation } from 'react-i18next';
import { getEnterpriseRoute } from 'utils';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './EnterpriseNavigation.styles.scss';

type EnterpriseNavigationProps = {
  className?: string;
};

const EnterpriseNavigation: React.FC<EnterpriseNavigationProps> = (props) => {
  const { className } = props;

  const classes = classNames('enterprise-navigation', className);

  const { isOfficeManager } = useContext(CurrentUserContext);
  const {
    enterprise: { _id },
  } = useContext(EnterpriseContext);

  const { t } = useTranslation();

  const links = useMemo(
    () => [
      ...(!isOfficeManager
        ? [
            {
              to: getEnterpriseRoute(false, false, _id, 'analytics'),
              label: t('overview'),
            },
          ]
        : []),
      {
        to: getEnterpriseRoute(false, false, _id, 'deals'),
        label: t('deals'),
      },
      { to: getEnterpriseRoute(false, false, _id, 'team'), label: t('team') },
      {
        to: getEnterpriseRoute(false, false, _id, 'configuration'),
        label: t('configuration'),
      },
      ...(!isOfficeManager
        ? [
            {
              to: getEnterpriseRoute(false, false, _id, 'branding'),
              label: t('branding'),
            },
          ]
        : []),
    ],
    [_id, isOfficeManager, t],
  );

  return <Subnav links={links} className={classes} />;
};

export default EnterpriseNavigation;
